import React from "react";
import { useI18n } from "../context/I18nContext.jsx";

const CONTENT = {
  nl: {
    title: "Privacybeleid",
    updated: "Laatst bijgewerkt: augustus 2026",
    sections: [
      {
        heading: "1. Wie zijn wij",
        body: `ZyncFit is een virtuele pas-app (SaaS) die door webwinkels wordt ingezet zodat hun klanten kleding virtueel kunnen passen en een persoonlijk maatadvies kunnen krijgen.

ZyncFit wordt aangeboden door:
[NOG IN TE VULLEN: Juridische bedrijfsnaam]
[NOG IN TE VULLEN: Vestigingsadres]
KvK-nummer: [NOG IN TE VULLEN]
E-mail: privacy@zyncport.com

De webwinkel waar u de pas-sessie start is de verwerkingsverantwoordelijke in de zin van de AVG. ZyncFit treedt op als verwerker en verwerkt persoonsgegevens uitsluitend in opdracht van de webwinkel.`,
      },
      {
        heading: "2. Welke gegevens verwerken wij",
        body: `Wij verwerken de volgende persoonsgegevens van eindklanten:

• Foto (selfie) — u maakt een foto via de camera in de widget. Deze wordt gebruikt om een virtueel pasbeeld te genereren.
• Lichaamsgegevens — lengte, gewicht en optioneel leeftijd, die u zelf invoert voor het maatadvies.
• E-mailadres — om u het resultaat (landingspagina) per e-mail toe te sturen.
• Naam — optioneel, bij het aanmaken van een klantaccount.
• Telefoonnummer — optioneel, bij het aanmaken van een klantaccount.
• Wachtwoord — bij accountregistratie, opgeslagen als beveiligde hash (bcrypt), nooit als leesbare tekst.
• IP-adres — uitsluitend om uw toestemming juridisch vast te leggen.
• Toestemmingsgegevens — of u akkoord bent gegaan met het privacybeleid en eventuele marketingtoestemming, inclusief datum.

Van webwinkels (merchants) verwerken wij:
• Shopify-winkeldomein en toegangstoken — voor de koppeling met de Shopify-winkel.
• Sessiegegevens uit het Shopify OAuth-proces.`,
      },
      {
        heading: "3. Waarvoor gebruiken wij uw gegevens",
        body: `Wij verwerken uw gegevens voor de volgende doeleinden:

1. Virtuele try-on — Uw foto en de kledingfoto worden naar Google Gemini AI gestuurd om een realistisch pasbeeld te genereren.
2. Maatadvies — Op basis van uw lengte, gewicht en (optioneel) leeftijd berekenen wij lichaamsmaten met antropometrische modellen en koppelen deze aan maattabellen van de webwinkel.
3. E-mailverzending — Het resultaat (link naar uw persoonlijke landingspagina) wordt per e-mail naar u verstuurd.
4. Klantaccount — Optioneel kunt u een account aanmaken om eerdere sessies terug te zien.
5. Conversie-analytics — De webwinkel kan meten of een try-on tot een aankoop heeft geleid, door uw e-mailadres te matchen met Shopify-orders. Dit is uitsluitend zichtbaar voor de webwinkel.
6. Verbetering maatadvies — Retour- en ruilgegevens (via de Zyncport-integratie) worden gebruikt om het maatadvies over tijd te verbeteren.

Uw foto wordt niet gebruikt voor het trainen van AI-modellen door ZyncFit en wordt nooit verkocht of gedeeld met derden voor marketingdoeleinden.`,
      },
      {
        heading: "4. Rechtsgrondslag",
        body: `Wij verwerken uw persoonsgegevens op basis van de volgende grondslagen (art. 6 AVG):

• Toestemming (art. 6 lid 1 sub a) — Voor het maken en verwerken van uw foto en lichaamsgegevens. U geeft hiervoor expliciet toestemming voordat u de try-on start. U kunt deze toestemming op elk moment intrekken.
• Uitvoering van de overeenkomst (art. 6 lid 1 sub b) — Voor het leveren van de dienst (virtueel pasbeeld en maatadvies) en het versturen van het resultaat per e-mail.
• Gerechtvaardigd belang (art. 6 lid 1 sub f) — Voor conversie-analytics ten behoeve van de webwinkel en voor de verbetering van het maatadvies.
• Uitdrukkelijke toestemming — Voor marketingcommunicatie (apart opt-in bij registratie).`,
      },
      {
        heading: "5. Derde partijen en sub-verwerkers",
        body: `Om onze dienst te leveren maken wij gebruik van de volgende derde partijen:

• Google Gemini AI (Google LLC, VS) — Uw foto en de kledingfoto worden naar Google Gemini gestuurd voor de generatie van het virtuele pasbeeld. Google verwerkt deze beelden uitsluitend voor de API-aanvraag. Betaalde API-aanroepen worden door Google niet gebruikt voor modeltraining.
• Resend (VS) — Voor het versturen van de resultaat-e-mail. Resend ontvangt uw e-mailadres, de link naar uw landingspagina, productnaam en winkelnaam.
• Vercel Inc. (VS) — Hosting van de applicatie. Alle verwerkte gegevens passeren de Vercel serverless-infrastructuur.
• PostgreSQL-database (Supabase) — Opslag van alle gegevens. [NOG IN TE VULLEN: exacte regio/locatie van de database]
• Shopify Inc. (Canada/VS) — Ordergegevens worden opgehaald via de Shopify Admin API voor conversie-analytics.
• Zyncport — Server-to-server integratie voor retour/ruil-feedback ter verbetering van maatadvies.

Doorgifte buiten de EER: Sommige sub-verwerkers zijn gevestigd in de Verenigde Staten. Wij zorgen ervoor dat passende waarborgen aanwezig zijn, zoals Standard Contractual Clauses (SCC's) of het EU-U.S. Data Privacy Framework.`,
      },
      {
        heading: "6. Bewaartermijnen",
        body: `Wij bewaren uw gegevens niet langer dan noodzakelijk:

• Foto's (selfies) en AI-gegenereerde pasbeelden — worden automatisch verwijderd na maximaal 90 dagen via een dagelijkse opschoningstaak.
• Sessiegegevens (zonder foto) — zoals maatadvies en productkeuze, kunnen langer bewaard blijven voor uw eigen overzicht als u een account heeft.
• Klantaccounts — blijven bestaan totdat u verwijdering aanvraagt of de webwinkel uw gegevens verwijdert.
• Merchant-gegevens — worden volledig verwijderd 48 uur na de-installatie van de app (Shopify shop/redact webhook).

[NOG IN TE VULLEN: Exacte bewaartermijnen voor klantaccounts bij inactiviteit]`,
      },
      {
        heading: "7. Beveiliging",
        body: `Wij nemen passende technische en organisatorische maatregelen om uw gegevens te beschermen:

• Wachtwoorden worden opgeslagen als beveiligde hash (bcrypt met 12 rounds) — nooit als leesbare tekst.
• Communicatie verloopt via HTTPS (TLS-encryptie).
• Shopify-webhooks worden geverifieerd via HMAC-SHA256 met tijdveilige vergelijking.
• Authenticatie via JWT-tokens met een beperkte geldigheidsduur van 30 dagen.
• Server-to-server integraties zijn beveiligd met Bearer-tokens.
• E-mailadressen worden gevalideerd en genormaliseerd.
• Shopify OAuth met nonce/state-verificatie ter voorkoming van CSRF-aanvallen.`,
      },
      {
        heading: "8. Uw rechten",
        body: `Op grond van de AVG heeft u de volgende rechten:

• Recht op inzage — U kunt opvragen welke gegevens wij van u verwerken.
• Recht op rectificatie — U kunt onjuiste gegevens laten corrigeren.
• Recht op verwijdering — U kunt verzoeken dat uw gegevens worden gewist. Verwijderverzoeken via de webwinkel (Shopify) worden automatisch verwerkt.
• Recht op beperking van de verwerking — U kunt de verwerking in bepaalde gevallen laten beperken.
• Recht op dataportabiliteit — U kunt uw gegevens in een gangbaar formaat opvragen.
• Recht om toestemming in te trekken — U kunt uw toestemming op elk moment intrekken, zonder dat dit afbreuk doet aan de rechtmatigheid van de verwerking vóór intrekking.
• Recht om een klacht in te dienen — U kunt een klacht indienen bij de Autoriteit Persoonsgegevens (autoriteitpersoonsgegevens.nl).

Om uw rechten uit te oefenen kunt u contact opnemen met de webwinkel waar u de pas-sessie startte, of rechtstreeks met ons via privacy@zyncport.com.`,
      },
      {
        heading: "9. Cookies",
        body: `ZyncFit plaatst zelf geen cookies. Authenticatie verloopt via JWT-tokens in HTTP-headers. De Shopify-webwinkel en hostingprovider (Vercel) kunnen eigen functionele cookies plaatsen; raadpleeg hiervoor het cookiebeleid van de betreffende webwinkel.`,
      },
      {
        heading: "10. Minderjarigen",
        body: `ZyncFit is niet specifiek gericht op kinderen. [NOG IN TE VULLEN: minimumleeftijd voor gebruik, bijv. 16 jaar conform AVG of 13 jaar]`,
      },
      {
        heading: "11. Wijzigingen in dit privacybeleid",
        body: `Wij kunnen dit privacybeleid van tijd tot tijd aanpassen. De meest recente versie is altijd beschikbaar op deze pagina. Bij wezenlijke wijzigingen zullen wij u hierover informeren.`,
      },
      {
        heading: "12. Contact",
        body: `Heeft u vragen over dit privacybeleid of over de verwerking van uw persoonsgegevens? Neem contact met ons op:

E-mail: privacy@zyncport.com
[NOG IN TE VULLEN: Postadres]
[NOG IN TE VULLEN: Functionaris Gegevensbescherming, indien aangesteld]`,
      },
    ],
  },
  en: {
    title: "Privacy Policy",
    updated: "Last updated: August 2026",
    sections: [
      {
        heading: "1. Who we are",
        body: `ZyncFit is a virtual try-on app (SaaS) used by online stores to enable their customers to virtually try on clothing and receive personalised size advice.

ZyncFit is provided by:
[TO BE COMPLETED: Legal entity name]
[TO BE COMPLETED: Address]
Chamber of Commerce: [TO BE COMPLETED]
Email: privacy@zyncport.com

The online store where you start the try-on session is the data controller under the GDPR. ZyncFit acts as a data processor and processes personal data solely on behalf of the online store.`,
      },
      {
        heading: "2. What data we process",
        body: `We process the following personal data of end customers:

• Photo (selfie) — you take a photo via the camera in the widget. This is used to generate a virtual try-on image.
• Body data — height, weight, and optionally age, which you enter yourself for the size recommendation.
• Email address — to send you the result (landing page) by email.
• Name — optional, when creating a customer account.
• Phone number — optional, when creating a customer account.
• Password — upon account registration, stored as a secure hash (bcrypt), never in plain text.
• IP address — solely to legally record your consent.
• Consent data — whether you agreed to the privacy policy and any marketing consent, including date.

From online stores (merchants) we process:
• Shopify store domain and access token — for the integration with the Shopify store.
• Session data from the Shopify OAuth process.`,
      },
      {
        heading: "3. How we use your data",
        body: `We process your data for the following purposes:

1. Virtual try-on — Your photo and the garment photo are sent to Google Gemini AI to generate a realistic try-on image.
2. Size advice — Based on your height, weight, and (optionally) age, we calculate body measurements using anthropometric models and match these to the store's size charts.
3. Email delivery — The result (link to your personal landing page) is sent to you by email.
4. Customer account — Optionally, you can create an account to review previous sessions.
5. Conversion analytics — The store can measure whether a try-on led to a purchase by matching your email address with Shopify orders. This is only visible to the store.
6. Improving size advice — Return and exchange data (via the Zyncport integration) are used to improve size recommendations over time.

Your photo is not used to train AI models by ZyncFit and is never sold or shared with third parties for marketing purposes.`,
      },
      {
        heading: "4. Legal basis",
        body: `We process your personal data on the following legal bases (Art. 6 GDPR):

• Consent (Art. 6(1)(a)) — For taking and processing your photo and body data. You give explicit consent before starting the try-on. You may withdraw this consent at any time.
• Performance of a contract (Art. 6(1)(b)) — For delivering the service (virtual try-on image and size advice) and sending the result by email.
• Legitimate interest (Art. 6(1)(f)) — For conversion analytics on behalf of the online store and for improving size recommendations.
• Explicit consent — For marketing communications (separate opt-in upon registration).`,
      },
      {
        heading: "5. Third parties and sub-processors",
        body: `To deliver our service, we use the following third parties:

• Google Gemini AI (Google LLC, US) — Your photo and the garment photo are sent to Google Gemini for try-on image generation. Google processes these images solely for the API request. Paid API calls are not used by Google for model training.
• Resend (US) — For sending the result email. Resend receives your email address, the link to your landing page, product name, and store name.
• Vercel Inc. (US) — Application hosting. All processed data passes through Vercel's serverless infrastructure.
• PostgreSQL database (Supabase) — Storage of all data. [TO BE COMPLETED: exact region/location]
• Shopify Inc. (Canada/US) — Order data is retrieved via the Shopify Admin API for conversion analytics.
• Zyncport — Server-to-server integration for return/exchange feedback to improve size advice.

Transfer outside the EEA: Some sub-processors are based in the United States. We ensure appropriate safeguards are in place, such as Standard Contractual Clauses (SCCs) or the EU-U.S. Data Privacy Framework.`,
      },
      {
        heading: "6. Retention periods",
        body: `We do not retain your data longer than necessary:

• Photos (selfies) and AI-generated try-on images — are automatically deleted after at most 90 days via a daily cleanup task.
• Session data (without photos) — such as size advice and product choice, may be kept longer for your own overview if you have an account.
• Customer accounts — remain active until you request deletion or the store removes your data.
• Merchant data — is fully deleted 48 hours after uninstalling the app (Shopify shop/redact webhook).

[TO BE COMPLETED: Exact retention periods for inactive customer accounts]`,
      },
      {
        heading: "7. Security",
        body: `We take appropriate technical and organisational measures to protect your data:

• Passwords are stored as secure hashes (bcrypt with 12 rounds) — never in plain text.
• Communication is encrypted via HTTPS (TLS).
• Shopify webhooks are verified via HMAC-SHA256 with timing-safe comparison.
• Authentication via JWT tokens with a limited validity of 30 days.
• Server-to-server integrations are secured with Bearer tokens.
• Email addresses are validated and normalised.
• Shopify OAuth with nonce/state verification to prevent CSRF attacks.`,
      },
      {
        heading: "8. Your rights",
        body: `Under the GDPR, you have the following rights:

• Right of access — You can request which data we process about you.
• Right to rectification — You can have incorrect data corrected.
• Right to erasure — You can request that your data be deleted. Deletion requests via the online store (Shopify) are processed automatically.
• Right to restriction of processing — You can restrict processing in certain cases.
• Right to data portability — You can request your data in a common format.
• Right to withdraw consent — You may withdraw your consent at any time, without affecting the lawfulness of processing prior to withdrawal.
• Right to lodge a complaint — You can file a complaint with the Dutch Data Protection Authority (autoriteitpersoonsgegevens.nl).

To exercise your rights, contact the online store where you started the try-on session, or contact us directly at privacy@zyncport.com.`,
      },
      {
        heading: "9. Cookies",
        body: `ZyncFit does not place any cookies itself. Authentication is handled via JWT tokens in HTTP headers. The Shopify store and hosting provider (Vercel) may place their own functional cookies; please refer to the cookie policy of the relevant online store.`,
      },
      {
        heading: "10. Minors",
        body: `ZyncFit is not specifically aimed at children. [TO BE COMPLETED: minimum age for use, e.g. 16 years under GDPR or 13 years]`,
      },
      {
        heading: "11. Changes to this privacy policy",
        body: `We may update this privacy policy from time to time. The most recent version is always available on this page. In case of material changes, we will inform you accordingly.`,
      },
      {
        heading: "12. Contact",
        body: `Do you have questions about this privacy policy or about the processing of your personal data? Contact us:

Email: privacy@zyncport.com
[TO BE COMPLETED: Postal address]
[TO BE COMPLETED: Data Protection Officer, if appointed]`,
      },
    ],
  },
  de: {
    title: "Datenschutzerklärung",
    updated: "Zuletzt aktualisiert: August 2026",
    sections: [
      {
        heading: "1. Wer wir sind",
        body: `ZyncFit ist eine virtuelle Anprobe-App (SaaS), die von Onlineshops eingesetzt wird, damit Kunden Kleidung virtuell anprobieren und eine persönliche Größenempfehlung erhalten können.

ZyncFit wird angeboten von:
[NOCH AUSZUFÜLLEN: Rechtliche Unternehmensbezeichnung]
[NOCH AUSZUFÜLLEN: Adresse]
Handelsregister: [NOCH AUSZUFÜLLEN]
E-Mail: privacy@zyncport.com

Der Onlineshop, in dem Sie die Anprobe starten, ist Verantwortlicher im Sinne der DSGVO. ZyncFit ist Auftragsverarbeiter und verarbeitet personenbezogene Daten ausschließlich im Auftrag des Onlineshops.`,
      },
      {
        heading: "2. Welche Daten wir verarbeiten",
        body: `Wir verarbeiten folgende personenbezogene Daten von Endkunden:

• Foto (Selfie) — Sie machen ein Foto über die Kamera im Widget. Dieses wird zur Erstellung eines virtuellen Anprobebildes verwendet.
• Körperdaten — Größe, Gewicht und optional Alter, die Sie selbst für die Größenempfehlung eingeben.
• E-Mail-Adresse — um Ihnen das Ergebnis (Landingpage) per E-Mail zuzusenden.
• Name — optional, bei der Erstellung eines Kundenkontos.
• Telefonnummer — optional, bei der Erstellung eines Kundenkontos.
• Passwort — bei Kontoregistrierung, gespeichert als sicherer Hash (bcrypt), niemals im Klartext.
• IP-Adresse — ausschließlich zur rechtlichen Dokumentation Ihrer Einwilligung.
• Einwilligungsdaten — ob Sie der Datenschutzerklärung und ggf. der Marketingkommunikation zugestimmt haben, einschließlich Datum.

Von Onlineshops (Händlern) verarbeiten wir:
• Shopify-Shopdomain und Zugriffstoken — für die Integration mit dem Shopify-Shop.
• Sitzungsdaten aus dem Shopify-OAuth-Prozess.`,
      },
      {
        heading: "3. Wofür wir Ihre Daten verwenden",
        body: `Wir verarbeiten Ihre Daten für folgende Zwecke:

1. Virtuelle Anprobe — Ihr Foto und das Kleidungsfoto werden an Google Gemini AI gesendet, um ein realistisches Anprobebild zu erstellen.
2. Größenempfehlung — Anhand Ihrer Größe, Ihres Gewichts und (optional) Alters berechnen wir Körpermaße mit anthropometrischen Modellen und gleichen diese mit den Größentabellen des Shops ab.
3. E-Mail-Versand — Das Ergebnis (Link zu Ihrer persönlichen Landingpage) wird Ihnen per E-Mail zugesendet.
4. Kundenkonto — Optional können Sie ein Konto erstellen, um frühere Sitzungen einzusehen.
5. Conversion-Analytics — Der Shop kann messen, ob eine Anprobe zu einem Kauf geführt hat, indem Ihre E-Mail-Adresse mit Shopify-Bestellungen abgeglichen wird. Dies ist nur für den Shop sichtbar.
6. Verbesserung der Größenempfehlung — Retouren- und Umtauschdaten (über die Zyncport-Integration) werden zur Verbesserung der Größenempfehlung verwendet.

Ihr Foto wird von ZyncFit nicht zum Training von KI-Modellen verwendet und niemals an Dritte zu Marketingzwecken verkauft oder weitergegeben.`,
      },
      {
        heading: "4. Rechtsgrundlage",
        body: `Wir verarbeiten Ihre personenbezogenen Daten auf folgenden Rechtsgrundlagen (Art. 6 DSGVO):

• Einwilligung (Art. 6 Abs. 1 lit. a) — Für die Aufnahme und Verarbeitung Ihres Fotos und Ihrer Körperdaten. Sie erteilen hierzu vor Beginn der Anprobe eine ausdrückliche Einwilligung. Sie können diese jederzeit widerrufen.
• Vertragserfüllung (Art. 6 Abs. 1 lit. b) — Für die Erbringung der Dienstleistung (Anprobebild und Größenempfehlung) und den Versand des Ergebnisses per E-Mail.
• Berechtigtes Interesse (Art. 6 Abs. 1 lit. f) — Für Conversion-Analytics im Auftrag des Onlineshops und zur Verbesserung der Größenempfehlung.
• Ausdrückliche Einwilligung — Für Marketingkommunikation (separates Opt-in bei Registrierung).`,
      },
      {
        heading: "5. Dritte und Auftragsverarbeiter",
        body: `Zur Erbringung unserer Dienstleistung setzen wir folgende Dritte ein:

• Google Gemini AI (Google LLC, USA) — Ihr Foto und das Kleidungsfoto werden an Google Gemini zur Erstellung des Anprobebildes gesendet. Google verarbeitet diese Bilder ausschließlich für die API-Anfrage. Bezahlte API-Aufrufe werden von Google nicht zum Modelltraining verwendet.
• Resend (USA) — Für den Versand der Ergebnis-E-Mail. Resend erhält Ihre E-Mail-Adresse, den Link zu Ihrer Landingpage, Produktname und Shopname.
• Vercel Inc. (USA) — Hosting der Anwendung. Alle verarbeiteten Daten durchlaufen die Serverless-Infrastruktur von Vercel.
• PostgreSQL-Datenbank (Supabase) — Speicherung aller Daten. [NOCH AUSZUFÜLLEN: genaue Region/Standort]
• Shopify Inc. (Kanada/USA) — Bestelldaten werden über die Shopify Admin API für Conversion-Analytics abgerufen.
• Zyncport — Server-zu-Server-Integration für Retouren-/Umtausch-Feedback zur Verbesserung der Größenempfehlung.

Übermittlung außerhalb des EWR: Einige Auftragsverarbeiter haben ihren Sitz in den USA. Wir stellen sicher, dass geeignete Garantien bestehen, wie Standardvertragsklauseln (SCCs) oder das EU-U.S. Data Privacy Framework.`,
      },
      {
        heading: "6. Speicherfristen",
        body: `Wir speichern Ihre Daten nicht länger als nötig:

• Fotos (Selfies) und KI-generierte Anprobebilder — werden nach spätestens 90 Tagen automatisch durch eine tägliche Bereinigung gelöscht.
• Sitzungsdaten (ohne Foto) — wie Größenempfehlung und Produktwahl, können für Ihre eigene Übersicht länger aufbewahrt werden, wenn Sie ein Konto haben.
• Kundenkonten — bleiben bestehen, bis Sie die Löschung beantragen oder der Shop Ihre Daten entfernt.
• Händlerdaten — werden 48 Stunden nach Deinstallation der App vollständig gelöscht (Shopify shop/redact Webhook).

[NOCH AUSZUFÜLLEN: Genaue Speicherfristen für inaktive Kundenkonten]`,
      },
      {
        heading: "7. Sicherheit",
        body: `Wir treffen angemessene technische und organisatorische Maßnahmen zum Schutz Ihrer Daten:

• Passwörter werden als sichere Hashes gespeichert (bcrypt mit 12 Runden) — niemals im Klartext.
• Kommunikation ist über HTTPS (TLS) verschlüsselt.
• Shopify-Webhooks werden über HMAC-SHA256 mit zeitlich sicherem Vergleich verifiziert.
• Authentifizierung über JWT-Tokens mit einer begrenzten Gültigkeit von 30 Tagen.
• Server-zu-Server-Integrationen sind mit Bearer-Tokens gesichert.
• E-Mail-Adressen werden validiert und normalisiert.
• Shopify OAuth mit Nonce/State-Verifizierung zur Vermeidung von CSRF-Angriffen.`,
      },
      {
        heading: "8. Ihre Rechte",
        body: `Gemäß der DSGVO haben Sie folgende Rechte:

• Recht auf Auskunft — Sie können erfahren, welche Daten wir über Sie verarbeiten.
• Recht auf Berichtigung — Sie können fehlerhafte Daten korrigieren lassen.
• Recht auf Löschung — Sie können die Löschung Ihrer Daten verlangen. Löschanfragen über den Onlineshop (Shopify) werden automatisch verarbeitet.
• Recht auf Einschränkung der Verarbeitung — Sie können die Verarbeitung in bestimmten Fällen einschränken lassen.
• Recht auf Datenübertragbarkeit — Sie können Ihre Daten in einem gängigen Format anfordern.
• Recht auf Widerruf der Einwilligung — Sie können Ihre Einwilligung jederzeit widerrufen, ohne dass die Rechtmäßigkeit der Verarbeitung vor dem Widerruf berührt wird.
• Beschwerderecht — Sie können eine Beschwerde bei der zuständigen Datenschutzbehörde einreichen.

Um Ihre Rechte auszuüben, wenden Sie sich an den Onlineshop, in dem Sie die Sitzung gestartet haben, oder direkt an uns unter privacy@zyncport.com.`,
      },
      {
        heading: "9. Cookies",
        body: `ZyncFit setzt selbst keine Cookies. Die Authentifizierung erfolgt über JWT-Tokens in HTTP-Headern. Der Shopify-Shop und der Hosting-Anbieter (Vercel) können eigene funktionale Cookies setzen; bitte beachten Sie die Cookie-Richtlinie des jeweiligen Onlineshops.`,
      },
      {
        heading: "10. Minderjährige",
        body: `ZyncFit richtet sich nicht speziell an Kinder. [NOCH AUSZUFÜLLEN: Mindestalter für die Nutzung, z. B. 16 Jahre gemäß DSGVO oder 13 Jahre]`,
      },
      {
        heading: "11. Änderungen dieser Datenschutzerklärung",
        body: `Wir können diese Datenschutzerklärung von Zeit zu Zeit aktualisieren. Die aktuelle Version ist stets auf dieser Seite verfügbar. Bei wesentlichen Änderungen werden wir Sie entsprechend informieren.`,
      },
      {
        heading: "12. Kontakt",
        body: `Haben Sie Fragen zu dieser Datenschutzerklärung oder zur Verarbeitung Ihrer personenbezogenen Daten? Kontaktieren Sie uns:

E-Mail: privacy@zyncport.com
[NOCH AUSZUFÜLLEN: Postanschrift]
[NOCH AUSZUFÜLLEN: Datenschutzbeauftragter, falls bestellt]`,
      },
    ],
  },
};

export default function PrivacyPolicyPage() {
  const { lang } = useI18n();
  const c = CONTENT[lang] || CONTENT.nl;

  return (
    <div style={{ maxWidth: 760, margin: "0 auto", padding: "48px 24px 80px", fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", color: "#1a1a1a", lineHeight: 1.7 }}>
      <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 4 }}>{c.title}</h1>
      <p style={{ fontSize: 13, color: "#888", marginBottom: 36 }}>{c.updated}</p>
      {c.sections.map(({ heading, body }) => (
        <section key={heading} style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>{heading}</h2>
          <p style={{ fontSize: 15, color: "#333", whiteSpace: "pre-line", margin: 0 }}>{body}</p>
        </section>
      ))}
      <footer style={{ marginTop: 48, paddingTop: 20, borderTop: "1px solid #e5e5e5", textAlign: "center", fontSize: 12, color: "#aaa" }}>
        &copy; {new Date().getFullYear()} ZyncFit &mdash; Powered by Zyncport
      </footer>
    </div>
  );
}
